export const instance = {
    "title": "FastTony",
    "background": {
        "solid": "https://cdn.fasttony.com/public_files/background/default.png"
    },
    "store": {
        "productGrid": [
            "Post",
            "FastTonyPl",
            "Insta",
            "forsant",
            "LeadAds",
            "SmartCall",
            "CallMe",
            "BOT"
        ]
    },
    "callApp": {
        "napDocLink": "https://docs.google.com/spreadsheets/d/1uV6pUd_jHqRVCloD5pvRXPmf5IyT2ylQ1GTFVMJaxiY/edit?usp=sharing"
    },
    "companyName": "FastTony",
    "instanceName": "Fasttony",
    "favicon": "smart",
    "privacyPolicyUrl": "https://fasttony.com/pl/polityka-prywatnosci/",
    "termsUrl": "https://fasttony.com/pl/regulamin-uslugi/",
    "pwaName": "FastTony",
    "pwaShortName": "FastTony",
    "pwaDescription": "FastTony",
    "pwaThemeColor": "ffffff",
    "pwaBackgroundColor": "ffffff",
    "onboardingVideos": {
        "phoneVerification": "https://youtu.be/MeyTK8VuKvg",
        "termsOfService": "https://youtu.be/F0DwGby9ukQ",
        "marketingConsent": "https://youtu.be/A12dYvu4Y8g",
        "contactEmail": "https://youtu.be/KpDQ7sd68U4",
        "userSurvey1": "https://youtu.be/m_6DdGDACDU",
        "userSurvey2": "https://youtu.be/m_6DdGDACDU",
        "providerAuthorization": "https://youtu.be/s1DjSA9Bay0",
        "providerIntegration_facebook": "https://youtu.be/4IlWxoj8afI",
        "providerIntegration_google": "https://youtu.be/eWq6PAwgS7Y",
        "languageAndWebsites": "https://youtu.be/qXDr4WwKpDU",
        "competitorWebsites": "https://youtu.be/3g6Mv56MSaA",
        "projectSurvey": "https://youtu.be/TNsLnNM5l9I",
        "businessInfo": "https://youtu.be/JarpkjIgKKI",
        "clientInfo": "https://youtu.be/n6pQONzwhvA",
        "keywords": "https://youtu.be/VY5hW3fWpys",
        "demographics": "https://youtu.be/cKPkhW2BEDA",
        "shoppingBehaviors": "https://youtu.be/CfJbNS_q5-A",
        "purchaseObjections": "https://youtu.be/CfJbNS_q5-A",
        "clientDescription": "https://youtu.be/cKPkhW2BEDA",
        "geopointsFacebook": "https://youtu.be/kzeD7g_yqYw",
        "interestsFacebook": "https://youtu.be/QA1PDtuGk3M",
        "keyword": "https://youtu.be/MNIRdKhtYZU",
        "budgetFacebook": "https://youtu.be/EeuCBZXGODU",
        "pixel": "https://youtu.be/em-W2oMr6Lw",
        "onboardingSummary": "https://youtu.be/-vgp-rfIjZE"
    }
}